module.exports = __webpack_public_path__ + "static/img/img23.e02aa5cb.png";